<template>
  <span :class="'fake-link' + (additionalClasses ? ' ' + additionalClasses : '')" @click.stop="$emit('click', $event)">
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: 'FakeLink',
  props: {
    additionalClasses: {
      type: String,
      description: "Additional classes to apply",
      default: ""
    }
  }
}
</script>
<style lang="scss" scoped>
.fake-link {
  cursor: pointer;
  color: var(--v-primary-base);
  text-decoration: underline;
}
</style>